const allUnderscores = /_/g;
const allSpaces = / /g;
const space = ' ';
const underscore = '_';

const isString = string => typeof string === 'string';

const titleCase = string => isString(string) ? string.toLowerCase()
	.split(space)
	.map(word => `${ word.charAt(0).toUpperCase() }${ word.substring(1) }`)
	.join(space) : '';

const snakeToTitleCase = string => isString(string) ? titleCase(string.replace(allUnderscores, space)) : '';

const snakeCase = string => isString(string) ? string.toLowerCase().replace(allSpaces, underscore) : '';

const formatPhoneNumber = int => {
	const integers = int.toString();

	if (integers.length === 10) {
		const areaCode = integers.slice(0, 3);
		const prefixNumber = integers.slice(3, 6);
		const lineNumber = integers.slice(6, 10);

		return `(${ areaCode }) ${ prefixNumber }-${ lineNumber }`;
	}
};

// Expects a string from the database like 2016-06-01, and will return a date meant for US readers, like 6/1/2016. Note that we use UTC functions. This is because "new Date()" takes a UTC time, but the non UTC functions return localized values. E.g. new Date('2017-01').getFullYear() would return 2016 for time zones west of the date line. So we use getUTCFullYear, and so on.
const formatDate = dateString => {
	const date = new Date(dateString);
	const day = date.getUTCDate();
	// Month is 0 indexed, so add 1.
	const month = date.getUTCMonth() + 1;
	const year = date.getUTCFullYear();

	return `${ month }/${ day }/${ year }`;
};

const determinePlural = noun => {
	const suffix = noun.match(/(s|sh|ch|x|z|o)$/) ? 'es' : 's';

	return noun.match(/[^aeiou]y/) ? noun.replace(/y$/, 'ies') : `${ noun }${ suffix }`;
};

const pluralOf = (quantity, noun, override = null) => {
	const nouns = override ? override : determinePlural(noun);

	return quantity === 1 ? noun : nouns;
};

const pluralize = (quantity, noun, override = null) => {
	const pluralNoun = pluralOf(quantity, noun, override);

	return `${ quantity } ${ pluralNoun }`;
};

module.exports = {
	formatDate,
	formatPhoneNumber,
	isString,
	pluralize,
	pluralOf,
	snakeCase,
	snakeToTitleCase,
	titleCase
};



// WEBPACK FOOTER //
// ./frontend/a2i/js/lib/stringFormatter.js